import axios from "axios";
interface FormData {
  name: string;
  email: string;
  phone: string;
  course: string;
  mode: string;
  qualification: string;
  City?: any;
  country?: any;
  utm_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  page_url?: string;
  is_otp_verified: number;
  isVinecrmEnable?: boolean;
}

export const submitFormData = async (data: FormData, router: any) => {
  const isLpPage = router.asPath.startsWith("/lp/");
  const crmCountryCode = data?.phone?.startsWith("+234")
    ? "NIGERIA"
    : data.phone.startsWith("+254")
    ? "KENYA"
    : data.phone.startsWith("+27")
    ? "SOUTH AFRICA"
    : data.phone.startsWith("+256")
    ? "UGANDA"
    : data.phone.startsWith("+255")
    ? "TANZANIA"
    : data.phone.startsWith("+263")
    ? "ZIMBABWE"
    : data.phone.startsWith("+267")
    ? "BOTSWANA"
    : data.phone.startsWith("+211")
    ? "SOUTH SUDAN"
    : data.phone.startsWith("+260")
    ? "ZAMBIA"
    : data.phone.startsWith("+264")
    ? "NAMIBIA"
    : null;

  const leadsData = {
    Name: data?.name,
    Email: data?.email,
    Phone: data?.phone,
    Course: data?.course,
    Mode_of_Study: data.mode,
    Qualification: data?.qualification,
    Programme_Of_Interest: data?.course,
    Interested_Topic: data?.course,
    page_url: data?.page_url,
    City: data?.City || "",
    country: crmCountryCode ? crmCountryCode : data?.country || "",
    is_otp_verified: data?.is_otp_verified,
    source: isLpPage ? data.utm_source : "SA Website",
    campaign: data.utm_campaign,
    utm_source: data.utm_source || "SA Website",
    utm_campaign: data.utm_campaign,
    utm_id: data.utm_id,
    utm_url: data.page_url,
    utm_medium: data.utm_medium,
    utm_term: data.utm_term,
    utm_content: data.utm_content,
    utm_referrer: data.page_url,
  };

  let vinCrmData = null;
  if (crmCountryCode && data.isVinecrmEnable) {
    vinCrmData = {
      domain: "crm",
      type: "add_lead_to_crm",
      name: data.name,
      email: data.email,
      study_mode: data.mode,
      mobile: data.phone,
      interest: data.course,
      highest_qualification: data.qualification,
      country: crmCountryCode,
      city: data.City || "",
      source: isLpPage ? data.utm_source : "SA Website",
      campaign: data.utm_campaign,
      utm_source: data.utm_source || "SA Website",
      utm_campaign: data.utm_campaign,
      utm_id: data.utm_id,
      utm_url: data.page_url,
      utm_medium: data.utm_medium,
      utm_term: data.utm_term,
      utm_content: data.utm_content,
      utm_referrer: data.page_url,
      is_otp_verified: data?.is_otp_verified,
    };
  }

  if (leadsData?.Email || vinCrmData?.email) {
    try {
      const cmsApiUrl = process.env.VINE_CRM_API_BASE_URL;
      const leadsApiUrl = process.env.LEADS_API_BASE_URL;

      if (!leadsApiUrl) {
        throw new Error(
          "Leads API base URL is not defined in the environment variables"
        );
      }

      await axios.post(leadsApiUrl, leadsData);

      // Call VinCRM API if data exists
      if (vinCrmData) {
        if (!cmsApiUrl) {
          throw new Error(
            "VinCRM API base URL is not defined in the environment variables"
          );
        }
        await axios.post(cmsApiUrl, vinCrmData);
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error("Error submitting lead data:", error.message);
      } else {
        console.error("An unexpected error occurred:", error);
      }
      throw error;
    }
  }
};
